<template>
  <div :class="classes" class="copy-hash-and-link">
    <div class="copy-hash-and-link__container">
      <span v-if="link" class="copy-hash-and-link__hash">
        <a :href="link" target="_blank" class="txt--on-one-row txt--color-04">{{
          hash
        }}</a>
      </span>
      <span
        v-if="!link"
        class="copy-hash-and-link__hash txt--on-one-row txt--color-04"
      >
        {{ hash }}
      </span>
      <!-- <div class="copy-has-and-link__gradient"/> -->
    </div>
    <div
      v-if="hash"
      class="copy-hash-and-link__copy-btn"
      @click="$emit('copy', hash)"
    >
      <slot name="icon">
        <img :src="copyIcon">
      </slot>
    </div>
  </div>
</template>

<script>
import { sizeValidator } from '@/lib/utils'

export default {
  name: 'CopyHashAndLink',
  props: {
    hash: {
      type: [String, Object],
      required: true,
    },
    link: {
      validator: v => v === null || typeof v === 'string',
      default: null,
    },
    copyIcon: {
      type: String,
      default: require('@/assets/img/orange/copy_icon.svg'),
    },
    size: {
      type: String,
      validator: sizeValidator,
      default: 'm',
    },
    useOnMobile: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    classes () {
      return {
        [`copy-hash-and-link--${this.size}`]: this.size,
        'copy-hash-and-link--use-on-mobiles': this.useOnMobile,
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.copy-hash-and-link {
  $root: &;
  $sizes: (
    xs: 75px,
    s: 100px,
    m: 150px,
    l: 175px,
    xl: 200px,
  );

  // display: inline-flex;
  display: grid;
  grid-template-columns: auto toRem(16px);
  gap: toRem(4px);
  align-items: center;

  @each $size, $length in $sizes {
    &--#{$size} {
      #{$root}__container {
        max-width: $length;
      }
    }
  }

  &--use-on-mobiles {
    #{$root}__container {
      @include bp(m) {
        max-width: 100%;
      }
    }

    #{$root}__copy-btn {
      @include bp(m) {
        display: none;
      }
    }
  }

  &__container {
    overflow: hidden;
    text-overflow: ellipsis;
    // @include webkit-scroll();
  }

  &__copy-btn {
    cursor: pointer;
    width: toRem(16px);
    height: toRem(16px);

    img {
      height: toRem(16px);
      width: toRem(16px);
    }
  }
}
</style>
